<template>
    <NuxtLayout name="malt-full-layout">
        <div>
            <slot />
        </div>
    </NuxtLayout>
</template>
